import { Show, createSignal, onMount } from "solid-js";
import { LoginScreen } from "./components/auth/LoginScreen.tsx";
import { Dashboard } from "./components/layout/Dashboard.tsx";
import { AmbientCanvas } from "./components/ambient/AmbientCanvas.tsx";

/**
 * HOUSTON root. Phase 0: shows the login screen until the session
 * cookie is validated. Subsequent phases mount the Dashboard inside
 * the WebGL ambient canvas.
 */
export function App() {
  const [authed, setAuthed] = createSignal(false);

  onMount(async () => {
    try {
      const res = await fetch(`${import.meta.env.VITE_HOUSTON_API_URL ?? ""}/auth/me`, {
        credentials: "include",
      });
      setAuthed(res.ok);
    } catch {
      setAuthed(false);
    }
  });

  return (
    <>
      <AmbientCanvas />
      <Show when={authed()} fallback={<LoginScreen />}>
        <Dashboard />
      </Show>
    </>
  );
}
